import React from "react";
import { strings } from "../../common/i18n";
import useColumnsRows from "./useColumnsRows";
import Loading from "../../common/components/Loading";
import MatReactTable from "../../common/components/MaterialReactTable";
/**
 * Options Table Component
 */

export default () => {
    const { columns, rows, rowActions, loading } = useColumnsRows();

    return (
        <>
            {loading && <Loading loadingText="loadingOptions" />}
            <MatReactTable
                persistKey="settingsPreferences"
                columns={columns}
                data={rows}
                loading={loading}
                rowActions={rowActions}
                noRowsMessage={strings("messages.noOptions")}
            />
        </>
    );
};
